import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import validate from './modules/validate';
import participant from './modules/participant';
import manageAccount from './modules/manageAccount';
import editUser from './modules/editUser';
import fieldTemplates from './modules/fieldTemplates';
import reports from './modules/reports';
import groups from './modules/groups';
import messages from './modules/messages';
import massMessages from './modules/massMessages';
import massMessagesDetails from './modules/massMessagesDetails';
import imports from './modules/imports';
import workspace from './modules/workspace';
import accounts from './modules/accounts';
import generalSettings from "./modules/generalSettings";
import maintenance from "./modules/maintenance";
import formBuilder from "./modules/formBuilderIndex";
import emails from "./modules/emails";
import referrals from "./modules/referrals";
import referralConfirmation from "./modules/referralConfirmation";
import helper from "./modules/helper";
import formBuilderEditor from "./modules/formBuilderEditor";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    validate,
    participant,
    manageAccount,
    editUser,
    fieldTemplates,
    reports,
    groups,
    messages,
    massMessages,
    massMessagesDetails,
    imports,
    workspace,
    accounts,
    generalSettings,
    maintenance,
    formBuilder,
    formBuilderEditor,
    emails,
    referrals,
    helper,
    referralConfirmation,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js